document.addEventListener('DOMContentLoaded', function () {
  const endDate = document.getElementById('countdown');
  var year = endDate.dataset['year'];
  var month = endDate.dataset['month'];
  var day = endDate.dataset['day'];
  // Set the date we're counting down to
var countDownDate = (year+'-'+month+'-'+day);  
var countDownDate2 = new Date(countDownDate).getTime();
// Update the count down every 1 second
var x = setInterval(function() {

  // Get today's date and time
  var now = new Date().getTime();
  // Find the distance between now and the count down date
  var distance = countDownDate2 - now;

  // Time calculations for days, hours, minutes and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  // Display the result in the element with id="countdown"
  document.getElementById("countdown").innerHTML = "Aktion endet in "+days + " T " + hours + " Std. "
  + minutes + " Min. " + seconds + " Sek. ";

  // If the count down is finished, write some text 
  if (distance < 0) {
    clearInterval(x);
    document.getElementById("countdown").innerHTML = "LEIDER ABGELAUFEN";
  }
}, 1000);
}, false);